module.exports = __webpack_public_path__ + "static/img/badge_no.cdf6dfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video/badge_no.png
// module id = oKKT
// module chunks = 1